import { getClient } from '@/api/api-client';
import type { DocumentRelationExpandOpts, IDataRoom, IGetOneDataRoomResponse, ISaveDataRoom } from '@condo/domain';

export const fetchDataRooms = async (params?: { estateId?: number; mfhId?: number }): Promise<IDataRoom[]> => {
    return getClient('basecamp')
        .get('/data-room', { params })
        .then(response => response.data.dataRooms);
};

export const saveDataRoom = async (payload: Partial<ISaveDataRoom>): Promise<IDataRoom> => {
    return getClient('basecamp')
        .post('/data-room', payload)
        .then(response => response.data.dataRoom);
};

export const deleteDataRoom = async (dataRoomId: number): Promise<any> => {
    return getClient('basecamp')
        .delete(`/data-room/${dataRoomId}`)
        .then(response => response.data);
};

export const getOneDataRoom = async (dataRoomId: number, documentRelationExpandOpts: DocumentRelationExpandOpts): Promise<IGetOneDataRoomResponse> => {
    return getClient('basecamp')
        .get(`/data-room/${dataRoomId}`, {
            params: {
                documentRelationExpandOpts,
            },
        })
        .then(response => response.data);
};
